/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ff-category-chip-read-only[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
